var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mystery-mode_mystery-mode_1bAPW {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: 0.9;\n    background: transparent url(" + escape(require("./mystery.png")) + ") center center;\n    z-index: 50;\n    pointer-events: none;\n}\n", ""]);

// exports
exports.locals = {
	"mystery-mode": "mystery-mode_mystery-mode_1bAPW",
	"mysteryMode": "mystery-mode_mystery-mode_1bAPW"
};